import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-jcb': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M431.5 244.3v-32.3c41.2 0 38.5 0.2 38.5 0.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2 0.4-3.3 0.3-38.5 0.3zM474.3 264.5c7.5 1.5 13.5 8.3 13.5 17 0 9-6 15.5-13.5 17-2.8 0.7-3.2 0.5-42.8 0.5v-35c39.5 0 40-0.2 42.8 0.5zM576 80v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zM360.5 196.8c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2v-28.3c-47.6 24.7-107.5 22-107.5-31s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-0.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-0.3-120.3-0.3v127.5h122.7c24.3 0.1 42.3-12.9 42.3-33.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-jcb.js
// module id = 745
// module chunks = 0